import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { Table } from 'primeng/table';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { gridPageRequest } from '../../../model/common/common.model';
import { AddVendorBankLookupComponent } from '../add-vendor-bank-lookup/add-vendor-bank-lookup.component';
import { VendorService } from '../../../services/vendor.service';
import _ from 'lodash';

@Component({
  selector: 'app-vendor-bank-lookup',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './vendor-bank-lookup.component.html',
  styleUrl: './vendor-bank-lookup.component.scss'
})
export class VendorBankLookupComponent implements OnInit {

  @ViewChild('dt1') dt1: Table | undefined;

  constructor(
    public dialogService: DialogService,
    private config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private vendorService: VendorService
  ) { }


  loader: boolean = false;
  list: any[] = [];
  selected: any[] = [];
  searchKey: string | undefined;
  vendorCode: string | undefined;
  vendorId: number = 0;


  pageRequest: gridPageRequest = {
    pageIndex: 1,
    pageSize: 20,
    id: 0
  }


  ngOnInit(): void {
    this.vendorCode = this.config.data?.VendorCode;
    this.vendorId = this.config.data?.VendorId;

    this.loadVendorBank();
  }

  addVendorBank() {
    this.ref = this.dialogService.open(AddVendorBankLookupComponent, {
      header: `Add Vendor Bank Code for ${this.vendorCode}`,
      width: '80%',
      data: { VendorCode: this.vendorCode, VendorId: this.vendorId }
    });

    this.ref.onClose.subscribe((success: boolean) => {
      if (success) {
        this.loadVendorBank();
      }
    });
  }

  editSelectedBank() {
    if (!this.selected || this.selected.length !== 1) {
      return;
    }
    this.editBank(this.selected[0]);
  }


  editBank(row: any) {
    this.ref = this.dialogService.open(AddVendorBankLookupComponent, {
      header: `Edit Vendor Bank - ${row.accountHolderName}`,
      width: '80%',
      data: {
        isEdit: true,
        bank: row,
        VendorId: this.vendorId,
        VendorCode: this.vendorCode
      }
    });

    this.ref.onClose.subscribe((success: boolean) => {
      if (success) {
        this.selected = [];
        this.loadVendorBank();
      }
    });
  }


  refreshData() {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.searchKey = '';
    this.pageRequest.pageSize = 20;
    this.loadVendorBank();
    this.selected = [];
  }



  loadVendorBank() {
    if (!this.vendorId || this.vendorId <= 0) {
      console.error('VendorId is missing');
      return;
    }

    this.loader = true;

    const request = {
      pageIndex: 1,
      pageSize: 1000,
      Id: this.vendorId
    };

    this.vendorService.getVendorBank(request).subscribe({
      next: (res: any) => {
        this.list = res.vendorBankAccount || [];
        this.selected = [];
        this.loader = false;
      },
      error: (err) => {
        this.loader = false;
        console.error(err);
      }
    });
  }


  deleteVendorBank() {
    if (!this.selected || this.selected.length === 0) return;

    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        this.loader = true;

        const bankIds = this.selected.map(x => x.vendorBankAccountId);

        this.vendorService.deleteVendorBank(bankIds).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Bank Deleted successfully.'
            });
            this.loader = false;
            this.selected = [];
            this.refreshData();
          },
          error: () => {
            this.loader = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Failed',
              detail: 'Error occurred while deleting.'
            });
          }
        });
      }
    });
  }


setPrimary(row: any) {
  if (row.isPrimary) return;

  this.confirmationService.confirm({
    header: 'Are you sure?',
    message: `Set this ${row.bankName} as Primary Bank Account?`, 
    accept: () => {
      const payload = {
        vendorBankAccountId: row.vendorBankAccountId,
        vendorId: this.vendorId
      };

      this.vendorService.setPrimaryVendorBank(payload).subscribe({
        next: () => {
          this.messageService.add({ 
            severity: 'success',
            summary: 'Updated',
            detail: 'Primary Bank Updated'  
          });
          this.refreshData();
        }
      });
    }
  });
}



}
